import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { BaseContainer } from '@adornis/buildify/db/extensions/BaseContainer.js';

@Entity()
export class CampusBaseContainer extends BaseContainer {
  static override _class = 'CampusBaseContainer';

  @Field(() => Float) opacity: Maybe<number>;
}
